import { createLoaderImp } from '../../../../../components/ozmoit/common';
import { StudentsRiskHistoryAction } from '../actions';
import { StudentsRiskHistoryParams } from '../types';

const {
  useLoaderData: StudentsRiskHistoryLoaderData,
  LoaderConsumerSimple: StudentsRiskHistoryLoaderConsumer,
  LoaderProvider: StudentsRiskHistoryLoaderProvider,
  useLoader: StudentsRiskHistoryLoader,
} = createLoaderImp({
  action: async (query: StudentsRiskHistoryParams) => {
    const res = await StudentsRiskHistoryAction(query);
    return res;
  },
});

export {
  StudentsRiskHistoryLoaderProvider,
  StudentsRiskHistoryLoaderConsumer,
  StudentsRiskHistoryLoaderData,
  StudentsRiskHistoryLoader,
};
